// API configuration - supports multiple deployments via environment variable
export const API_BASE_URL = import.meta.env.PROD
  ? (import.meta.env.VITE_API_URL || "https://dishsnap-api.codorders.workers.dev")
  : "";

export function apiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}
